import { render, staticRenderFns } from "./InfoXboxLive.vue?vue&type=template&id=4b7694f0"
import script from "./InfoXboxLive.vue?vue&type=script&lang=js"
export * from "./InfoXboxLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports